import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";


export interface PatientProfile{
    id: number;
    name: string;
    birthday: string;
    gender: string;
    whatsapp_no: string;
    contact_no: string;
    nic: string;
    passport: string;
    country: string;
    address_line_1: string;
    address_line_2: string;
    address_line_3: string;
    status: number;
    ch_patient_id: string;
    continue_: number;
    added_by_system_user: number;
    patient_login_id: number | null;
    createdAt: string;
    updatedAt: string;
    weight: number;
    height: number;
    blood_type: string;
}

interface PatientProfileState {
    patientProfile: PatientProfile|null;
    patientProfileUp: PatientProfile|null;
    loading: boolean;
    error: string | null;
}

const initialState: PatientProfileState = {
    patientProfile: null,
    patientProfileUp: null,
    loading: false,
    error: null,
};
// const baseUrl = process.env.API_URL;
// Async thunk for fetching active blog categories
export const fetchPatientByCHY = createAsyncThunk<any,any>(
    'patient/fetchActive',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `https://alokait.lk/api/v1/patient-login/single-patient`,
                {id:id}
            );
            return response.data.patient;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to get Profile'
            );
        }
    }
);

export const searchPatientByCHY = createAsyncThunk<any,any>(
    'patient/searchPatientByCHY',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `https://alokait.lk/api/v1/patient-login/search-patient`,
                {id:id}
            );
            return response.data.patient;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to get Profile'
            );
        }
    }
);
export const createOrUpdatePatient = createAsyncThunk<any,PatientProfile>(
    'patient/createOrUpdatePatient',
    async (profile, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/patient-profile/create-or-update`,
                profile
            );
            // await AsyncStorage.setItem('profile', JSON.stringify(response.data.profileData));

            return response.data.profileData;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to get Profile'
            );
        }
    }
);

const patientSlice = createSlice({
    name: 'patient',
    initialState,
    reducers: {
        clearProfileError: (state) => {
            state.error = null;
          },
          clearProfile: (state) => {
            state.patientProfile = null;
          },
    }, extraReducers: (builder) => {
        builder
            .addCase(fetchPatientByCHY.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.patientProfile = null;
            })
            .addCase(fetchPatientByCHY.fulfilled, (state, action) => {
                state.loading = false;
                state.patientProfile = action.payload;
            })
            .addCase(fetchPatientByCHY.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading = false;
                state.patientProfile = null;
            })
            .addCase(searchPatientByCHY.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.patientProfile = null;
            })
            .addCase(searchPatientByCHY.fulfilled, (state, action) => {
                state.loading = false;
                state.patientProfile = action.payload;
            })
            .addCase(searchPatientByCHY.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading = false;
                state.patientProfile = null;
            })
            .addCase(createOrUpdatePatient.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.patientProfileUp = null;
            })
            .addCase(createOrUpdatePatient.fulfilled, (state, action) => {
                state.loading = false;
                state.patientProfileUp = action.payload;
            })
            .addCase(createOrUpdatePatient.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading = false;
                state.patientProfileUp = null;
            });
    },
});
// searchPatientByCHY
export const { clearProfileError,clearProfile } = patientSlice.actions;

export default patientSlice.reducer;
